import React, { useContext } from 'react';
import AdhesionAdUnit from '../AdUnit/Adhesion/Adhesion';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
const DevpageAdhesionPlacement = ()=>{
    const isDealerAdhesion = useFlag('dealer_json_adhesion');
    const { isLoggedIn } = useContext(SessionContext);
    const isMobile = useContext(MobileContext);
    // User
    if (isLoggedIn || isMobile || !isDealerAdhesion) {
        return null;
    }
    // Anon
    return /*#__PURE__*/ React.createElement(AdhesionAdUnit, {
        realEstateId: "166926a9-15ab-458d-b424-4385d5c9acde"
    });
};
DevpageAdhesionPlacement.displayName = 'DevpageAdhesionPlacement';
export default DevpageAdhesionPlacement;
